import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/environment.service';
import { Address, ImageRef } from '@app/services/api/api.service';
import { map, Observable, of, take, tap } from 'rxjs';

export interface SearchSuggestion {
  id: string | null;
  cityId: string | null;
  stateId: string | null;
  countryId: string | null;
  searchType: number | null;
  get display(): string;
}

// todo should this be distinct from CityRef?
export class PlaceRef implements SearchSuggestion {
  city: string;
  state: string;
  cityId: string;
  stateId: string;
  countryId: string;
  country: string;
  searchType: number;

  get id() {
    return this.cityId;
  }

  // if this.city is not null, return this.city, this.country
  // else return this.country
  get display() {
    console.log('this', this);
    if(this.searchType === 4) {
      return this.country;
    }
    
    return this.city ? `${this.city}, ${this.country}` : `${this.state}, ${this.country}`;
  }
}

export class HostelRef implements SearchSuggestion {
  id: string;
  name: string;
  address: Address;
  cityId: string | null;
  stateId: string | null;
  countryId: string | null;
  images: ImageRef[];
  overallRating: number | null;
  searchType: number | null;

  get display() {
    return this.name;
  }
}

export interface PlacesResp {
  success: boolean;
  data: {
    cities: PlaceRef[];
    states: PlaceRef[];
    hostels: HostelRef[];
    countries: PlaceRef[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PlacesService {
  private CACHE_TIMEOUT = 60_000;

  private cache: Record<string, { timestamp: number; res: any }> = {};

  constructor(
    private http: HttpClient,
    private environment: EnvironmentService
  ) {}

  search(keywords: string): Observable<any> {
    if (this.cache[keywords]) {
      if (
        this.cache[keywords].timestamp >
        new Date().getTime() - this.CACHE_TIMEOUT
      ) {
        return of(this.cache[keywords].res.data).pipe(take(1));
      }
    }
    return this.http
      .post<PlacesResp>(
        `${this.environment.apiUrl}/api/v1/backpacker/hostel/search-auto-suggestion`,
        { searchKey: keywords }
      )
      .pipe(
        tap((res) => {
          if (res.success) {
            this.cache[keywords] = {
              res,
              timestamp: new Date().getTime(),
            };
          }
        }),
        map((resp) => resp.data)
      );
  }
}
